import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../services/auth-service';

/**
 * Login component that redirects to Cognito Hosted UI
 */
export function Login() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  useEffect(() => {
    // If already authenticated, redirect to dashboard
    if (authService.isAuthenticated()) {
      window.location.href = '/';
      return;
    }

    // If a callback/token exchange is currently being processed, don't
    // auto-redirect to the hosted UI. Let the callback flow finish.
    if ((authService as any).isProcessing && (authService as any).isProcessing()) {
      // leave the page showing the redirecting UI while processing
      return;
    }

    // Auto-redirect to Cognito Hosted UI if no error
    if (!error) {
      authService.login();
    }
  }, [error]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.424-.833-2.194 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Authentication Error</h3>
            <p className="text-sm text-gray-600 mb-4">
              {error === 'callback_failed' ? 'Failed to complete sign in. Please try again.' : 'An error occurred during authentication.'}
            </p>
            <button
              onClick={() => authService.login()}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to sign in...</p>
      </div>
    </div>
  );
}
